import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { DateHelper } from "src/app/common/helpers/date-helper";
import { GuidGenerator } from "src/app/common/helpers/guid-generator";
import { TruthyCheck } from "src/app/common/helpers/truthy-check";
import { AddressViewModel } from "src/app/common/models/AddressViewModel";
import { IndividualNameViewModel } from "src/app/common/models/IndividualNameViewModel";
import { MemberViewModel } from "src/app/common/models/MemberViewModel";
import { MultiMediaBasicInfo } from "src/app/common/models/MultiMediaBasicInfo";
import { ParentMessageType } from "src/app/common/models/ParentMessage";
import { ResponseModel } from "src/app/common/models/ResponseModel";
import { LoadingService } from "src/app/services/UI/loading.service";
import { MembereditorService } from "../services/membereditor.service";
import { ParentCommunicatorService } from "src/app/services/parent-communicator.service";
import {
  TooltipPosition,
  DateTooltipPlace,
  MultimediaPopupOpenMode,
  ImageCarouselActionsTypes,
  MultimediaTypes,
  CropFrameMode,
  EditorMode
} from "src/app/common/enums/enums";
import { Subscription } from "rxjs";
import { PreferencesService } from "src/app/services/preferences.service";
import { first } from "rxjs/operators";
import { Observable, Subject } from "rxjs";
import { CustomError } from "src/app/common/helpers/custom-error";
import { PopupResponseEvents } from "src/app/common/enums/enums";
import {
  MultimediaPopupResponse,
  PlacePopupResponse,
} from "src/app/common/models/PopupResponse";
import { PlacemanagementService } from "../../common/place/services/placemanagement.service";
import {
  MultimediaPopupInputInfo,
  PlacePopupInputInfo,
} from "src/app/common/models/PopupInputInfo";
import { SuggestionItemsMapper } from "src/app/common/mappers/SuggestionItemsMapper";
import { IndividualMultiMediaViewModel } from "src/app/common/models/IndividualMultiMediaViewModel";
import { PlaceInfo } from "src/app/common/models/PlaceInfo";
import { LinkRequest } from "src/app/common/models/LinkRequest";
import { ConfirmationInputInfo } from "src/app/common/models/ConfirmationInputInfo";
import { ConfirmationContent } from "src/app/common/models/ConfirmationContent";
import { ConfirmationDialogService } from "src/app/services/UI/confirmation-dialog.service";
import { IndividualBaseViewModel } from 'src/app/common/models/IndividualViewModel';
import { MultimediamanagementService } from '../../common/multimedia/services/multimediamanagement.service';
import { TreeEditorApiService } from '../../treeeditor/services/treeeditorapi.service';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHandler } from "src/app/common/helpers/translate-handler";

@Component({
    selector: "app-member-editor",
    templateUrl: "./member-editor.component.html",
    styleUrls: ["./member-editor.component.scss"],
    standalone: false
})
export class MemberEditorComponent implements OnInit {
  public isLeftPanelHide: boolean;
  fileAdded: boolean = true;
  dateString: string;
  showWarning: boolean = false;
  tooltipPosition: TooltipPosition;
  memberViewData: MemberViewModel;
  selectedImage: MultiMediaBasicInfo;
  isVisible: boolean;
  dateTooltipPlace: DateTooltipPlace;
  dateTooltipPlaceDeath: DateTooltipPlace;
  nameSettingKey: string = "";
  includePrefixSuffix: boolean = true;
  includeMiddleName: boolean = true;
  includePatronomic: boolean = true;
  nameOrder: string;
  isLastNameFirst: boolean = false;

  preference: any;
  commonAddress: string;

  memberPlacesList: any;
  mappedMemberPlacesList: any;
  memberSelectedDeathPlace: any;
  memberSelectedBirthPlace: any;
  numberOfsuggestions: number = 3;

  memeberId: number;
  memberMediaViewData: IndividualMultiMediaViewModel;
  multimediaLoaded: boolean = false;
  showValidation: boolean = false;
  isSaveEnable: boolean = true;

  @ViewChild("memberEditForm") form: any;

  subscriptionLeftPanelHide: Subscription;
  membereditorServiceSubscribe: Subscription;
  birthDateSubscribe: Subscription;
  deathDateSubscribe: Subscription;
  rootMemberChangedServiceSubscription: Subscription;
  onVisibilityChangedServiceSubscription: Subscription;
  confirmationServiceSubscription: Subscription;

  private subscriptionRootMemberId;
  rootMemberId: number;
  errorImg: string = "assets/images/no-image.jpg";
  suggestionItemsMapper: SuggestionItemsMapper;
  defaultImage: string = "";
  isMediaChanged: boolean;
  multimediaSubscription: any;
  timeTag: string;
  label: IndividualBaseViewModel = new IndividualBaseViewModel;
  refreshParent: any;
  memberName: string;

  @Output() edittedImage = new EventEmitter<MultiMediaBasicInfo>();


  constructor(
    private membereditorService: MembereditorService,
    private parentCommunicatorService: ParentCommunicatorService,
    private loadingService: LoadingService,
    private dateHelper: DateHelper,
    private truthyCheck: TruthyCheck,
    private PreferencesService: PreferencesService,
    private placemanagmentservice: PlacemanagementService,
    private confirmationDialogService: ConfirmationDialogService,
    private translateService: TranslateService,
    private multimediamanagementService: MultimediamanagementService,
    private treeEditorApiService: TreeEditorApiService,
    private translateHandler: TranslateHandler
  ) {
    this.subscriptionLeftPanelHide = this.parentCommunicatorService.getLeftPanelHideObs.subscribe(
      (IsExpand) => {
        //this code use to apply relavant styles base on left panel view status
        this.isLeftPanelHide = IsExpand;
      }
    );

    this.rootMemberChangedServiceSubscription = this.membereditorService
      .onRootMemberChanged()
      .subscribe(() => this.selectedMemberDetails());
  }

  ngOnInit(): void {
    this.tooltipPosition = TooltipPosition.Right;
    this.dateTooltipPlace = DateTooltipPlace.MemberEditor;
    this.memberMediaViewData = new IndividualMultiMediaViewModel();
    this.rootMemberChangedServiceSubscription = this.membereditorService
      .onRootMemberChanged()
      .subscribe(() => {
        this.selectedMemberDetails();
        this.getPlaceList();
        this.selectedMemberMediaDetails();
      });

    this.membereditorServiceSubscribe = this.membereditorService
      .onVisibilityChanged()
      .subscribe((response) => {
        this.showValidation = false;
        if (!response) {
          this.selectedImage = null;
          this.memberViewData = null;
          this.memberViewData.birthFTDate = null;
          this.memberViewData.deathFTDate = null;
          this.form.reset();
        } else {
          this.selectedMemberDetails();
          this.getPlaceList();
          this.selectedMemberMediaDetails();
        }
      });
  }

  getPlaceList() {
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);
    this.membereditorService
      .getPlaces()
      .subscribe((response: ResponseModel<MemberViewModel>) => {
        console.log("Place data received");
        this.memberPlacesList = response.data;
        this.suggestionItemsMapper = new SuggestionItemsMapper();
        this.mappedMemberPlacesList = this.suggestionItemsMapper.map(
          this.memberPlacesList
        );
      })
      .add(() => {
        this.loadingService.hide(processId);
      });
  }

  selectedMemberDetails() {
    this.setNameSettingPreference();
    this.selectedImage = new MultiMediaBasicInfo();
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);
    this.membereditorService
      .getMember()
      .subscribe(
        (response: ResponseModel<MemberViewModel>) => {
          console.log("Member data received");
          this.memberViewData = null;
          this.memberViewData = new MemberViewModel();
          this.memberViewData.name = new IndividualNameViewModel();
          this.memberViewData = response.data;
          this.memberViewData.birthPlace.addressString =
            response.data.birthPlace.addressString;
          this.memberViewData.birthPlace.id = response.data.birthPlace.id;
          this.memberViewData.deathPlace.addressString =
            response.data.deathPlace.addressString;
          this.memberViewData.deathPlace.id = response.data.deathPlace.id;
          this.defaultImage = this.memberViewData.gender == "M" ? "assets/images/Male.png" : "assets/images/Female.png";
          if (
            this.memberViewData.birthDate &&
            !this.memberViewData.birthFTDate
          ) {
            this.memberViewData.birthFTDate = this.dateHelper
              .validateAndFormat(this.memberViewData.birthDate);
          }
          if (
            this.memberViewData.deathDate &&
            !this.memberViewData.deathFTDate
          ) {
            this.memberViewData.deathFTDate = this.dateHelper
              .validateAndFormat(this.memberViewData.deathDate);
          }
          this.selectedImage = this.memberViewData.media.find(
            (x) => x.id == this.memberViewData.selectedMultimediaId
          );
          this.rootMemberId = this.memberViewData.id;
          this.loadingService.hide(processId);
        },
        (error) => {
          this.loadingService.hide(processId);
          throw new CustomError("Please try again", 911, false);
        }
      )
      .add(() => {
        this.loadingService.hide(processId);
      });
  }

  addressFormatter(address: AddressViewModel) {
    let addressLines = new Array<String>();
    if (this.truthyCheck.isEmptyObject(address)) return "";
    else {
      if (address.streetName_Detail)
        addressLines.push(address.streetName_Detail);
      if (address.streetNumber_line2)
        addressLines.push(address.streetNumber_line2);
      if (address.postalCode_line3) addressLines.push(address.postalCode_line3);
      if (address.postOffice_line4) addressLines.push(address.postOffice_line4);
      if (address.county_line5) addressLines.push(address.county_line5);
      if (address.country) addressLines.push(address.country);

      return addressLines.join(", ");
    }
  }

  onCancel() {
    this.unsubscribeSubscriptions();
  }

  showNotImplemented() {
    this.parentCommunicatorService.send(
      ParentMessageType.ShowInformation,
      "not_implemented"
    );
  }

  //Open place pop to select place for a event
  showPlacePopup(customTitle: string, placeId: number): Observable<any> {
    let level = 0;
    let popWidth = "47%";
    let membername = this.memberViewData.name.givenName + " " + this.memberViewData.name.surName;
    let selectedImageIds: number[] = new Array();
    selectedImageIds.push(placeId);
    var subject = new Subject<any>();
    let popupInputData = new PlacePopupInputInfo(customTitle, popWidth, membername, level, selectedImageIds, MultimediaPopupOpenMode.List);
    this.placemanagmentservice.openPopup(popupInputData).pipe(first()).subscribe(
      (data: PlacePopupResponse) => {
        if (data.Status == PopupResponseEvents.Error) {
          throw new CustomError("Invalid place info", 611, false);
        }
        subject.next(data.Info);
      },
      (err) => {
        throw err;
      }
    );
    return subject.asObservable();
  }

  addBirthPlace() {
    let placeId = this.memberViewData.birthPlace.id;
    let title = this.translateHandler.translate("lbl_add_birth_place");
    this.showPlacePopup(title, placeId).subscribe((res: PlaceInfo) => {
      this.memberViewData.birthPlace.id = res.id;
      this.memberViewData.birthPlace.addressString = res.fullAddress;
    });
  }

  addDeathPlace() {
    let placeId = this.memberViewData.deathPlace.id;
    let title = this.translateHandler.translate("lbl_add_death_place");
    this.showPlacePopup(title, placeId).subscribe((res: PlaceInfo) => {
      this.memberViewData.deathPlace.id = res.id;
      this.memberViewData.deathPlace.addressString = res.fullAddress;
    });
  }

  //Need to refactor later
  setNameSettingPreference() {
    let preference = this.PreferencesService.get();
    if (preference) {
      this.includePrefixSuffix = preference.includePrefixSuffix;
      this.includeMiddleName = preference.includeMiddleName;
      this.includePatronomic = preference.includePatronomic;
      this.nameOrder = preference.nameOrder;
      this.nameSettingKey = this.genarateNameSettingKey(preference);
      this.isLastNameFirst = this.setNameOrderPrefernce(preference);
    }
  }

  // Need to refactor later
  genarateNameSettingKey(preference: any): string {
    let pre = preference.includePrefixSuffix ? "1" : "0";
    let middle = preference.includeMiddleName ? "1" : "0";
    let patro = preference.includePatronomic ? "1" : "0";
    return pre + middle + patro;
  }

  setNameOrderPrefernce(preference: any): boolean {
    let isLastNameFirst = preference.nameOrder === "lastFirst" || preference.nameOrder === "lastCommaFirst" ? true : false;
    return isLastNameFirst;
  }

  // Concat the name for multimedia popup title
  concatName() {
    this.memberName = this.memberViewData.name.givenName + " " + this.memberViewData.name.middleName + " " + this.memberViewData.name.surName;
  }

  validate() {
    this.showValidation = true;
  }

  update() {
    if (this.form.valid) {
      if (this.memberViewData.name.surName == "") {
        this.validate();
      } else {
        this.showValidation = false;
        let formData = new FormData();
        let memberData = { ...this.memberViewData };
        memberData.media = [];
        formData.append("memberInfo", JSON.stringify(memberData));

        let processId = GuidGenerator.generate();
        this.loadingService.show(processId);
        this.membereditorService.updateMember(formData).subscribe(
          (response: ResponseModel<MemberViewModel>) => {
            // this.membereditorService.ShowMember(false);
            // this.editorHeaderService.changeEditor(EditorMode.TreeEditor);
            this.loadingService.hide(processId);
          },
          (err) => {
            this.loadingService.hide(processId);
            throw new CustomError(
              "DateHelper => FormatDate() : " + err,
              911,
              false
            );
          }
        );
        this.unsubscribeSubscriptions();
      }
    }
  }

  setGender(gender: string) {
    this.memberViewData.gender = gender;
  }

  isAlive(livingStatus: boolean) {
    this.memberViewData.isAlive = livingStatus;
  }

  dateValueSelected(birthOrDeath, formattedDate) {
    if (birthOrDeath === "birth") {
      this.memberViewData.birthDate = formattedDate.formattedText;
      this.memberViewData.birthFTDate = formattedDate;
    } else if (birthOrDeath === "death") {
      this.memberViewData.deathDate = formattedDate.formattedText;
      this.memberViewData.deathFTDate = formattedDate;
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
  }

  selectedDeathPlace($event) {
    this.memberSelectedDeathPlace = $event;
    this.memberViewData.deathPlace.addressString = this.memberSelectedDeathPlace.name;
    this.memberViewData.deathPlace.id = this.memberSelectedDeathPlace.id;
  }

  selectedBirthPlace($event) {
    this.memberSelectedBirthPlace = $event;
    this.memberViewData.birthPlace.addressString = this.memberSelectedBirthPlace.name;
    this.memberViewData.birthPlace.id = this.memberSelectedBirthPlace.id;
  }

  unsubscribeSubscriptions() {
    this.parentCommunicatorService.close(
      ParentMessageType.RootMemberChanged,
      this.subscriptionRootMemberId
    );
    this.subscriptionLeftPanelHide.unsubscribe();
    this.onVisibilityChangedServiceSubscription.unsubscribe();
    this.rootMemberChangedServiceSubscription.unsubscribe();
    this.membereditorServiceSubscribe.unsubscribe();
    this.birthDateSubscribe.unsubscribe();
    this.deathDateSubscribe.unsubscribe();

    this.defaultImage = "";
    this.multimediaLoaded = false;
  }

  selectedMemberMediaDetails() {
    this.selectedImage = new MultiMediaBasicInfo();
    this.memberMediaViewData = new IndividualMultiMediaViewModel();
    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);
    this.membereditorService
      .getReferencedMultimedias()
      .pipe(first())
      .subscribe((response: ResponseModel<IndividualMultiMediaViewModel>) => {
        this.memberMediaViewData = null;
        this.memberMediaViewData = new IndividualMultiMediaViewModel();
        this.memberMediaViewData = response.data;
        if (this.memberMediaViewData.media.length > 0) {
          this.multimediaLoaded = true;
        }

        this.selectedImage = this.memberMediaViewData.media.find(
          (x) => x.id === this.memberMediaViewData.selectedMultimediaId
        );
      })
      .add(() => {
        this.loadingService.hide(processId);
      });
  }

  modifyProfileImage(profileImageFunction: any) {
    this.isMediaChanged = false;
    if (profileImageFunction.type == ImageCarouselActionsTypes.SetAsPrimary) {
      this.setImageAsPrimary(profileImageFunction.selectedMediaInfo);
    } else if (profileImageFunction.type == ImageCarouselActionsTypes.Unlink) {
      this.unlinkImage(profileImageFunction.selectedMediaInfo);
    }
    if (profileImageFunction.type === ImageCarouselActionsTypes.Edit) {
      this.editImage(profileImageFunction.selectedMediaInfo, MultimediaPopupOpenMode.Edit);
    }
    if (profileImageFunction.type === ImageCarouselActionsTypes.Upload) {
      this.editImage(profileImageFunction.selectedMediaInfo, MultimediaPopupOpenMode.List);
    }
  }

  setImageAsPrimary(mediaInfo: MultiMediaBasicInfo) {
    let linkRequest = new LinkRequest();
    linkRequest.TargetId = mediaInfo.id;

    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);
    this.membereditorService.updateMultimediaLink(linkRequest, this.memberViewData.id).subscribe(() => {
      this.loadingService.hide(processId);
    }, (err) => {
      this.loadingService.hide(processId);
      throw new CustomError("MemberEditorComponent => SetImageAsPrimary() : " + err, 911, false);
    });
  }

  unlinkImage(mediaInfo: MultiMediaBasicInfo) {
    this.showDeleteConfirmation(mediaInfo);
  }

  showDeleteConfirmation(mediaInfo: MultiMediaBasicInfo) {
    let isConfirmed: boolean;
    let confirmationDialogHeader = "lbl_unlink_confirmation_header";
    let confirmationDialogfooter = "cnf_unlink_confirmation";
    let confirmationDialogBody = this.translateService.instant('cnf_unlink_confirmation_body');

    let popupInputData = new ConfirmationInputInfo();
    popupInputData.Visibility = true;
    let confirmationContent = new ConfirmationContent();
    confirmationContent.ConfirmationDialogHeader = confirmationDialogHeader;
    confirmationContent.ConfirmationDialogBody = confirmationDialogBody;
    confirmationContent.ConfirmationDialogFooter = confirmationDialogfooter;
    popupInputData.ConfirmationContent = confirmationContent;

    this.confirmationServiceSubscription = this.confirmationDialogService.OpenPopup(popupInputData)
      .pipe(first()).subscribe((response: boolean) => {
        if (response) {
          this.unlinkSelectedImage(mediaInfo);
        }
        else {

        }
      },
        (err) => {
          throw new CustomError("MultimediaComponent => ShowDeleteConfirmation() : " + err, 911, false);
        }
      );
  }

  unlinkSelectedImage(mediaInfo: MultiMediaBasicInfo) {
    let linkRequest = new LinkRequest();
    linkRequest.TargetId = mediaInfo.id;

    let processId = GuidGenerator.generate();
    this.loadingService.show(processId);
    this.membereditorService.unlinkMultimediaLink(mediaInfo.id, this.memberViewData.id)
      .subscribe(() => {
        this.isMediaChanged = true;
        this.loadingService.hide(processId);
      },
        (err) => {
          this.loadingService.hide(processId);
          throw new CustomError("MemberEditorComponent => SetImageAsPrimary() : " + err, 911, false);
        }
      );
  }


  editImage(mediaInfo: MultiMediaBasicInfo, mode: MultimediaPopupOpenMode = MultimediaPopupOpenMode.List) {
    this.concatName();
    this.openMultiMedia(mediaInfo, mode).subscribe((res: MultimediaPopupResponse) => {
      this.isMediaChanged = true;
    });

  }

  // Open MultiMedia popup to add/edit profile image
  openMultiMedia(mediaInfo: MultiMediaBasicInfo, mode: MultimediaPopupOpenMode): Observable<any> {
    let popupInputData = new MultimediaPopupInputInfo();
    popupInputData.level = 0;
    popupInputData.Title = this.translateHandler.translate('lbl_profile_picture_of', [this.memberName]);
    popupInputData.Mode = mode;
    popupInputData.FilterMode = [MultimediaTypes.PHOTO];
    popupInputData.CropFrameMode = CropFrameMode.Circle;
    popupInputData.SelectedImageIds = popupInputData.SetImageIds(mediaInfo.id);
    popupInputData.AcceptedMultimediaTypes = [MultimediaTypes.PHOTO];
    popupInputData.PopUpTitle = "lbl_all_media";
    popupInputData.IsFullScreenPopUp = false;
    popupInputData.PopupWidth = "47%";
    popupInputData.MediaToEdit = mediaInfo;

    var subject = new Subject<any>();

    // Opens the multimedia panels and selection of the media or cancel steps
    this.multimediaSubscription = this.multimediamanagementService.openPopup(popupInputData)
      .pipe(first())
      .subscribe((selectedImages: MultimediaPopupResponse) => {
        if (selectedImages.Status == PopupResponseEvents.Error) {
          throw new CustomError("Image url is invalid", 611, false);
        }

        subject.next(selectedImages.Data);

        //Update user profile image if new imaege "selected"
        if ((selectedImages.Status === PopupResponseEvents.Selected ||
          selectedImages.Status === PopupResponseEvents.DeSelected || selectedImages.Status === PopupResponseEvents.Edited) && selectedImages.Data) {
          if (selectedImages.Status === PopupResponseEvents.DeSelected) {
            selectedImages.Data[0].mediaUrl = null;
            selectedImages.Data[0].id = null;
          }
          let linkRequest = new LinkRequest;
          linkRequest.TargetId = selectedImages.Status === PopupResponseEvents.Selected || selectedImages.Status === PopupResponseEvents.Edited ? selectedImages.Data[0].id : null;

          let processId = GuidGenerator.generate();
          this.loadingService.show(processId);
          this.treeEditorApiService.updateMultimediaLink(linkRequest, this.memberViewData.id).subscribe(
            () => {
              this.timeTag = "&timeTag=" + new Date().getTime(); // used to avoid caching
              this.label.profileImage = selectedImages.Data[0].mediaUrl;
              this.label.profileImageId = selectedImages.Data[0].id;

              this.loadingService.hide(processId);

              this.edittedImage.emit(selectedImages.Data[0]);
            },
            (err) => {
              this.loadingService.hide(processId);
              throw new CustomError("MainlabelsComponent => OpenMultiMedia() : " + err, 911, false);
            }
          )
        }
        else {
          if (selectedImages.Status === PopupResponseEvents.Edited) {
            this.edittedImage.emit(selectedImages.Data[0]);
          }

          if (selectedImages.Status === PopupResponseEvents.Cancelled && selectedImages.reload) {
            this.timeTag = "&timeTag=" + new Date().getTime(); // used to avoid caching
            this.refreshParent.emit(selectedImages.reload);
          }
        }
      },
        (err) => {
          throw new CustomError("MainlabelsComponent => OpenMemberEditor() : " + err, 911, false);
        }
      )
    return subject.asObservable();
  }

}
